// ============================================
// PATCH NOTES - Update this file with each release
// ============================================
// Format: { version: "x.x.x", date: "YYYY-MM-DD", changes: [...] }
// Change types: "feature" | "fix" | "improvement" | "security"
// ============================================

export const CURRENT_VERSION = "1.0.0";

export const PATCH_NOTES = [
  {
    version: "1.0.0",
    date: "2025-02-08",
    title: "Initial Release",
    changes: [
      { type: "feature", text: "Create and join location-based events" },
      { type: "feature", text: "Real-time group chat for event participants" },
      { type: "feature", text: "Interactive map with event markers" },
      { type: "feature", text: "User profiles with customizable avatars" },
      { type: "feature", text: "Event sharing via unique links" },
      { type: "feature", text: "Guest view for shared events" },
      { type: "feature", text: "Participant management for organizers" },
      { type: "feature", text: "Push notifications for event updates" },
    ]
  },
  // Add new releases at the TOP of this array
  // Example:
  // {
  //   version: "1.1.0",
  //   date: "2025-02-15",
  //   title: "Chat Improvements",
  //   changes: [
  //     { type: "feature", text: "Added emoji reactions to messages" },
  //     { type: "fix", text: "Fixed message delivery status not updating" },
  //     { type: "improvement", text: "Improved chat loading performance" },
  //   ]
  // },
];